// extracted by mini-css-extract-plugin
module.exports = {"mobile_album":"Album_mobile_album__4Krh4"};